/* eslint-disable @typescript-eslint/ban-types */
import IconError from '@apollo/icons/default/IconError.svg';
import IconInfo from '@apollo/icons/default/IconInfo.svg';
import IconMegaphone from '@apollo/icons/default/IconMegaphone.svg';
import IconSparklesSolid from '@apollo/icons/default/IconSparklesSolid.svg';
import IconSuccess from '@apollo/icons/default/IconSuccess.svg';
import IconWarning from '@apollo/icons/default/IconWarning.svg';
import { ChakraComponent, chakra } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import {
  AdmonitionVariant,
  useAdmonitionContext,
  useAdmonitionStyles,
} from '../Admonition/Admonition.context';

const VARIANTS: Record<
  AdmonitionVariant,
  ChakraComponent<React.FunctionComponent<React.SVGAttributes<SVGElement>>>
> = {
  neutral: chakra(IconMegaphone),
  info: chakra(IconInfo),
  success: chakra(IconSuccess),
  warning: chakra(IconWarning),
  error: chakra(IconError),
  beta: chakra(IconSparklesSolid),
};

export function getVariantIcon(variant: AdmonitionVariant) {
  return VARIANTS[variant];
}

export type AdmonitionIconProps = {
  icon?: React.FunctionComponent<React.SVGAttributes<SVGElement>> | undefined;
};

export const AdmonitionIcon = ({ icon }: AdmonitionIconProps) => {
  const variant = useAdmonitionContext();
  const styles = useAdmonitionStyles();

  const Icon = useMemo(() => {
    return icon ? chakra(icon) : getVariantIcon(variant);
  }, [icon, variant]);

  return <Icon __css={styles.icon} />;
};
